// extracted by mini-css-extract-plugin
export var fadeInAnimation = "DefaultHero-module--fadeInAnimation--1714c";
export var show = "DefaultHero-module--show--2222c";
export var video = "DefaultHero-module--video--0385d";